<template>
  <div class="container py-4 py-lg-5 my-lg-5 px-4 px-sm-0">
    <div class="card p-4 rounded-0 bg-faded">
      <h2 class="fs-xxl fw-500 mt-4  text-center">
        {{ $t('titles.accept-invitation') }}
        <small class="h3 fw-300 mt-3 mb-5 opacity-60"
          >{{ message }} <br />
          {{ $t('text.accept-invitation') }}
        </small>
      </h2>

      <div class="row no-gutters">
        <div class="col-lg-12 pl-lg-1 my-2 text-center">
          <button class="btn btn-smart btn-lg rounded-pill" @click="accept()">{{ $t('buttons.yes') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { notificationsMixin } from '@/mixins/notifications';
import { acceptResource } from '@/resources/accept.resource';
import { teamResource } from '@/resources/team.resource';
import { InvitationTypes } from '@/enums/invitationTypes.enum';

// @vuese
// Akceptacja zaproszeń
// @group Start
export default {
  mixins: [notificationsMixin],
  data() {
    return {
      type: this.$route.params.type,
      token: this.$route.params.token
    };
  },
  methods: {
    // @vuese
    // Akceptuje zaproszenie
    accept() {
      acceptResource
        .accept(this.type, this.token)
        .then(() =>
          this.$store.dispatch('showConfirm', {
            title: 'Zaakceptowano zaproszenie',
            showCloseButton: false,
            submitButton: 'Ok',
            onSuccess: () => this.$router.push({ name: 'login' })
          })
        )
        .catch(err => this.notifyError(err.message || 'messages.errorLong'));
    }
  },
  computed: mapState({
    message: state => state.accept.message
  })
};
</script>
